import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import { store } from './store';
import VuetifyConfirm from 'vuetify-confirm'
import VueCookies from 'vue-cookies'
import FlagIcon from 'vue-flag-icon'
import VueFlags from "@growthbunker/vueflags";
Vue.use(VueFlags,{
  iconPath: '/flags/',
});
Vue.config.productionTip = false;
Vue.prototype.$API =  "https://backend-seller.egmokka.com";
Vue.prototype.$Version =  "v1.240603";
Vue.use(FlagIcon);
Vue.use(VuetifyConfirm, { vuetify })
Vue.use(VueCookies)
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
